module.exports = __webpack_public_path__ + "img/csservice.abc3c088.jpg";